import { Button } from '@egw/components'
import { configClient } from '@egw/config'
import { useTranslation } from '@egw/i18n'
import { EnrollmentHYCSLayout } from '@egw/layouts'
import { type FC } from 'react'
import { PageHeader } from '../../../components'
import { type Config } from '../../../config/config'

export const DeviceNotSupportedPage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const config = configClient.getConfig() as Config

  const onSubmit = (): void => {
    window.open(config.zendeskArticles.helpCenterFAQs, '_blank')
  }

  return (
    <EnrollmentHYCSLayout title={t('generic.device_not_supported.page_title')}>
      <div className="egw-container-enroll-hycs h-full flex flex-col relative md:justify-center justify-start items-start">
        <PageHeader title={t('generic.device_not_supported.title')} />
        <div className="flex flex-col gap-md">
          <p className="typo-primary-base text-text-body">{t('generic.device_not_supported.description_1')}</p>
          <p className="typo-primary-base text-text-body">{t('generic.device_not_supported.description_2')}</p>
        </div>
        <div className="flex-1 md:hidden" />

        <Button type="button" className="w-full md:w-min mt-xl" onClick={onSubmit} testId="primaryAction_button">
          {t('generic.device_not_supported.cta')}
        </Button>
      </div>
    </EnrollmentHYCSLayout>
  )
}
